import React from 'react';

import { getInstructionStatusLabel } from '@data/instruction';
import {
  CustomsStatusName,
  CustomsRequestStatusName,
  getCustomsStatusLabel,
  getCustomsRequestStatusLabel,
} from '@models/next/CustomsRequestStatus';
import { DeliveryRequestStatusName } from '@models/next/DeliveryRequestStatus';
import { DOStatusName } from '@models/next/DOStatus';
import { InstructionStatusName } from '@models/next/Instruction';
import { MoveOutStatusName } from '@models/next/MoveOutStatus';
import { PreAlertLedgerLockStatus } from '@models/next/PreAlert';
import { InvoiceStatus, PaymentSlipStatus } from '@models/next/StatusFlows';
import { createStrings } from '@utils/local';

export const bookingsStrings = createStrings({
  ja: {
    title: () => ({
      beforeDeparture: '進行中の案件(出港前)',
      afterDeparture: '進行中の案件(出港後)',
      past_finished: '過去の案件',
      past_canceled: 'キャンセル済',
      all: '全ての案件',
    }),
    booking: '予約',
    bookingManagement: '案件管理',
    bookingInquiryHistory: '最新予約',
    currentBookings: '進行中の案件',
    pastBookings: '過去の案件',
    exportCSV: 'Export CSV',
    searchTitle: '絞り込み',
    account: '会員番号',
    from: 'から',
    to: 'まで',
    id: 'NO.',
    d2dNo: 'D2D番号',
    vessel: '船名',
    pod: 'POD',
    pol: 'POL',
    etd: 'ETD',
    eta: 'ETA',
    consignee: 'CNEE',
    shipper: 'SHIPPER',
    paymentTime: '受付時間',
    companyName: '会社名',
    selectOneItemAtLeast: '少なくとも1つのアイテムを選択してください',
    reset: 'リセット',
    invalidEndDate: '検索開始日以降を指定してください',
    emptyHint: 'お探しの案件はありません。',
    csManagerChina: 'CS(CN)',
    csManagerJapan: 'CS(JP)',
    preAlert: 'PRE ALERT',
    quantity: '個数',
    chinaChargeCheck: '中国费用检查',
    details: '詳細',
    generated: '作成済',
    myCases: '私の案件',
    memberSalesperson: '営業担当者',
    customsInstructionStatus: () => (
      <>
        通関
        <br />
        (客側)
      </>
    ),
    deliveryInstructionStatus: () => (
      <>
        配車
        <br />
        (客側)
      </>
    ),
    customsStatus: '通関状況',
    customsRequestStatus: '通関依頼',
    deliveryRequestStatus: '配車(CS)',
    salespersonCustoms: '通関担当者',
    preferredArrivalDate: 'お届け日',
    deliveryDate: 'お届け日',
    agency: '代理店',
    totalQuantityWeightMeasure: '総個数/総重量/総メジャー',
    status: 'ステータス',
    cancelReason: 'キャンセル理由',
  },
});
export const bookingsStringsCN = createStrings(
  {
    cn: {
      title: () => ({
        past_canceled: '已取消',
      }),
      cancelReason: '取消理由',
    },
  },
  'cn',
);

export const preAlertStatusOptions = [
  { value: '-' as const, label: '-' },
  { value: '作成済' as const, label: '作成済' },
  { value: undefined, label: 'ALL' },
];

export const preAlertTypeOptions = [
  { value: 'current_before_departure', label: '進行中の案件（出港前）' },
  { value: 'current_after_departure', label: '進行中の案件（出港後）' },
  { value: 'past_finished', label: '過去の案件' },
];

export const bookingStatusOptions = [
  { value: 'FCキャンセル済', label: 'FCキャンセル済' },
  { value: '客側キャンセル済', label: '客側キャンセル済' },
  { value: undefined, label: 'ALL' },
];

export const moveOutStatusOptions = [
  ...MoveOutStatusName.options.map((t) => ({
    label: t,
    value: t,
  })),
  { label: 'ALL', value: undefined },
];

export const doStatusOptions = [
  ...DOStatusName.options.map((t) => ({
    label: t,
    value: t,
  })),
  { label: 'ALL', value: undefined },
];

export const instructionStatusOptions = [
  ...InstructionStatusName.options.map((t) => ({
    label: getInstructionStatusLabel(t, true),
    value: t,
  })),
  { label: 'ALL', value: undefined },
];

export const customsStatusOptions = [
  ...CustomsStatusName.options.map((t) => ({
    label: getCustomsStatusLabel(t),
    value: t,
  })),
  { label: '-', value: '-' },
  { label: 'ALL', value: undefined },
];

export const customsReuqestStatusOptions = [
  ...CustomsRequestStatusName.options.map((t) => ({
    label: getCustomsRequestStatusLabel(t),
    value: t,
  })),
  { label: '-', value: '-' },
  { label: 'ALL', value: undefined },
];

export const deliveryRequestStatusOptions = [
  ...DeliveryRequestStatusName.options.map((t) => ({
    label: t,
    value: t,
  })),
  { label: '-', value: '-' },
  { label: 'ALL', value: undefined },
];

export const getInvoiceStatusOptions = () => [
  ...InvoiceStatus.options.map((t) => ({
    label: t,
    value: t,
  })),
  { label: 'ALL', value: undefined },
];

export const getPaymentSlipStatusOptions = () => [
  ...PaymentSlipStatus.options.map((t) => ({
    label: t,
    value: t,
  })),
  { label: 'ALL', value: undefined },
];

export const myCasesOptions = [
  { label: bookingsStrings.myCases, value: true },
  { label: 'ALL', value: false },
];

export const csManagerOptions = [
  { label: '-', value: null },
  { label: bookingsStrings.myCases, value: true },
  { label: 'ALL', value: false },
];

export const ledgerLockStatusOptions: {
  label: string;
  value: PreAlertLedgerLockStatus | undefined;
}[] = [
  { label: '準備中', value: 'preparing' },
  { label: '未ロック', value: 'not_locked' },
  { label: 'ロック済', value: 'locked' },
  { label: 'ALL', value: undefined },
];
